import { render, staticRenderFns } from "./preview-value.vue?vue&type=template&id=345bf254&"
import script from "./preview-value.vue?vue&type=script&lang=js&"
export * from "./preview-value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "preview-value.vue"
export default component.exports